import * as React from 'react'

import { cn } from '@/lib/utils'

export type InputProps = React.ComponentProps<'input'> & {
  className?: string
  prepend?: React.ReactNode
  append?: React.ReactNode
  // type?: 'text' | 'email' | 'password' | 'number' | 'tel' | 'url' | 'file'
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({
    className, prepend = null, append = null, 'aria-invalid': ariaInvalid, ...props
  }, ref) => {
    return (
      <div className={cn(
        'relative flex w-full space-x-2 rounded-md border border-input bg-background px-4 shadow-xs transition-all duration-300 focus-within:outline-hidden focus-within:ring-1 focus-within:ring-ring hover:border-primary/50',
        ariaInvalid && 'border-destructive',
      )}
      >
        {prepend && (
          <div className="text-gray pointer-events-none flex items-center text-base">
            {prepend}
          </div>
        )}
        <input
          // type={type}
          className={cn(
            'flex-1 py-3 !px-0 text-base bg-transparent focus:dark:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-placeholder disabled:cursor-not-allowed disabled:opacity-50 md:text-sm focus-visible:ring-0 !border-0 outline-hidden min-w-0',
            className,
          )}
          ref={ref}
          aria-invalid={ariaInvalid}
          {...props}
        />
        {append && (
          <div className="text-gray pointer-events-none flex items-center text-xs">
            {append}
          </div>
        )}
      </div>
    )
  },
)
Input.displayName = 'Input'

export { Input }
